export default {"src":"/_next/static/media/CF.59218c76.svg","height":18,"width":18};